// Domain utility functions
export const isPermitRockstarDomain = () => {
  return process.env.REACT_APP_BASE_URL === "https://permitrockstar.app";
};

export const shouldShowFormDigitizationUsers = () => {
  return !isPermitRockstarDomain();
};
